import { LineItem, ShopCheckoutSideBarResponse } from '../models'
import { ProductGeneralType } from '../types'

/*
 * This function will return applied promotion codes on the cart if there is any
 */
export const getCartAppliedPromotions = (productData: ShopCheckoutSideBarResponse | null): LineItem[] | undefined => {
  const appliedPromotions = productData?.lineItems.filter(item => item?.type === ProductGeneralType.PROMOTION)
  return appliedPromotions
}
